export default {
  SET_loading(state, payload) {
    state.loading = payload
  },
}
